/**
 * Entry point for the production-parity, non-persistent product demo.
 *
 * The real product pages are mounted under /demo/* with an `ephemeral`
 * flag. SessionContext is React memory only: a refresh or leaving the demo
 * clears answers, the selfie, the generated routine, and mirror snapshots.
 */
import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSession } from "../context/SessionContext";

export function DemoEntry() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { resetEphemeralDemo } = useSession();

  useEffect(() => {
    resetEphemeralDemo();
    navigate("/demo/onboarding", { replace: true });
  }, [navigate, resetEphemeralDemo]);

  return (
    <div
      className="min-h-screen trubeaute-gradient flex items-center justify-center px-6"
      data-testid="demo-entry-loading"
    >
      <div className="text-center text-[#5D4050]">
        <Sparkles className="h-7 w-7 mx-auto mb-3 text-[#9B6A6C] animate-pulse" />
        <p className="font-serif italic text-xl">{t("demo.ephemeral.opening")}</p>
      </div>
    </div>
  );
}

// Previously issued /demo/result/:token links pointed at stored MongoDB
// documents. The stateless demo deliberately has no resumable token, so old
// links restart cleanly instead of attempting a database read.
export function DemoLegacyResult() {
  return <Navigate to="/demo" replace />;
}
